export enum DocumentTypes {
  USER = 'user',
  UNIT = 'unit',
  PROPERTY = 'property',
}
